<template>
  <div class="flex justify-center  bg-white">
    <div class="absolute my-12 animate-spin h-10 w-10 border-4 border-blue-300 rounded-full border-t-transparent"></div>
    <div class="my-11 text-3xl text-gray-500">読み込み中...</div>
  </div>
  <hr>
  <div class="h-80"></div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false, required: true }
  }
}
</script>